import React from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as MetricActions from '../actions/Actions.js';
import DiscountCoupon from '../components/DiscountCoupon.jsx';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom'

class CouponPage extends React.Component{
  render(){
    return(
      <div>
        <Helmet>
          <title>Coupon Codes for Basketball Shoes</title>
        </Helmet>


        {/*<p id="breadcrumbs_react">
          <span>
            <span><a href={"/"}>Home</a> &nbsp;/&nbsp;
              <span><Link to={"/shoe-reviews/"}>Shoe Reviews</Link> &nbsp;/&nbsp;
                <span className="breadcrumb_last">Coupons</span>
              </span>
            </span>
          </span>
        </p>*/}



        <h1>Best Coupon Codes for Basketball Shoes:</h1>
        <div style={{marginTop:20}}>
          <Row>
            <Col lg={9} md={12}>
              <Row>
                {
                  this.props.discounts.map((discount,index)=>{
                    return(
                      <Col key={index} lg={4} md={4} sm={6} xs={12}>
                        <DiscountCoupon linkText="coupon_page" {...discount}/>
                      </Col>
                    );
                  })
                }
              </Row>
            </Col>

          </Row>
        </div>
        <div>
          Listed above you'll find some of the best coupons, discounts and promotion codes for online basketball shoe stores.
          To use a coupon simply click the coupon code then enter the code during the store's checkout process. Restrictions apply.
        </div>
      </div>
    );
  }
}





export default connect(state => ({discounts:state.data.discounts}), (dispatch) => ({
  actions: bindActionCreators(MetricActions, dispatch)
}))(CouponPage);
